<template>
    <div>
        <ValidationObserver ref="obs" v-slot="{ invalid }">
            <v-form name="formEditarCuenta" @submit.prevent="editarCuenta">
                <v-row :class="$vuetify.breakpoint.mdAndUp ? 'pa-0' : 'pb-12'" v-if="currentStep == 1">
                    <v-col cols="12" md="12" v-if="!ocultarAvisoCvu">
                        <v-alert color="secondary" outlined elevation="0" dense icon="mdi-information-outline"
                            class="px-5 mt-0 rounded-0 font-weight-regular text-body-1 secondary--text"
                            style="word-break: keep-all;">
                            Tené en cuenta que no podés adherir a débito automático cuentas de billeteras virtuales no
                            bancarizadas.
                            (CVU)
                        </v-alert>
                    </v-col>
                    <v-col cols="12" md="12" class="mb-3">
                        <div class="font-weight-regular text-subtitle-2 mb-1 grey--text text--darken-1">
                            Titular
                        </div>
                        <div style="border-bottom: 1px solid #aaa;">
                            {{ nomYApe }}
                        </div>
                    </v-col>
                    <v-col cols="12" md="12">
                        <ValidationProvider rules="required|length:22|numeric" v-slot="v">
                            <v-text-field v-model="cbu.deb_cbucompleto" label="CBU" dense :error-messages="v.errors[0]"
                                @keydown="preventArrowKeys" @input="validarCbu"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" md="12">
                        <ValidationProvider rules="required" v-slot="v">
                            <v-autocomplete v-model="selectedBancoId" :items="bancos" readonly label="Entidad bancaria"
                                dense :error-messages="v.errors[0]" item-text="nombre" item-value="id"
                                hide-details="auto" hide-no-data hide-selected :loading="validandoCbu"
                                :menu-props="{ closeOnContentClick: false }">
                                <template v-slot:append v-if="bancoAutocompletado">
                                    <v-icon color="green">mdi-check-circle</v-icon>
                                </template>
                            </v-autocomplete>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" md="12" class="d-flex justify-center">
                        <InputButtonArchivo @fileSelected="handleFileSelected" op="comprobanteCbu"
                            label="COMPROBANTE DE CBU" />
                    </v-col>
                </v-row>
            </v-form>
        </ValidationObserver>
    </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import InputButtonArchivo from '@/components/inputs/InputButtonArchivo.vue';

export default {
    name: 'FormEditarCuenta',
    mounted() {
        this.getBancos();
        // Cargar nomYApe con datos del usuario
        this.nomYApe = (this.user.apellido || '') + ', ' + (this.user.nombres || '');
        this.afiliado.nomYApe = this.nomYApe;
    },
    components: {
        ValidationObserver,
        ValidationProvider,
        InputButtonArchivo
    },
    watch: {

        cbu: {
            handler(newVal) {
                // Buscar el banco para obtener el nombre
                const bancoEncontrado = this.bancos.find(b => b.id === newVal.banco);
                // Emitir los datos actualizados al padre
                this.$emit('cuentaDataChanged', {
                    deb_cbu1: newVal.deb_cbu1 || '',
                    deb_cbu2: newVal.deb_cbu2 || '',
                    deb_estado: newVal.deb_estado || 'PA',
                    deb_cbucompleto: newVal.deb_cbucompleto || '',
                    banco: newVal.banco || null,
                    bco_nombre: bancoEncontrado ? bancoEncontrado.nombre : ''
                });
                this.checkFormValidity();
            },
            deep: true
        },
        check(newValue) {
            this.check = true;
            this.nomYApe = (this.user.apellido || '') + ', ' + (this.user.nombres || '');
            this.afiliado.nomYApe = this.nomYApe;
        },
        selectedBancoId(newValue) {
            if (newValue) {
                // Actualizar el banco en cbu
                this.cbu.banco = newValue;

                // Buscar el banco para obtener el nombre
                const bancoEncontrado = this.bancos.find(b => b.id === newValue);
                if (bancoEncontrado) {
                    this.cbu.bco_nombre = bancoEncontrado.nombre;
                }

                // Emitir los datos actualizados
                this.$emit('cuentaDataChanged', {
                    deb_cbu1: this.cbu.deb_cbu1 || '',
                    deb_cbu2: this.cbu.deb_cbu2 || '',
                    deb_estado: this.cbu.deb_estado || 'PA',
                    deb_cbucompleto: this.cbu.deb_cbucompleto || '',
                    banco: newValue,
                    bco_nombre: bancoEncontrado ? bancoEncontrado.nombre : ''
                });
                this.checkFormValidity();
            }
        },
        // Actualizar dest y dest_or en cada selección de la tabla
        activos(newVal) {
            this.updateDestForActivos();
            this.checkFormValidity();
        },
        // Si cambia el CBU completo volver a actualizar los seleccionados
        'afi_debautos.deb_cbucompleto'(val) {
            this.updateDestForActivos();
        },
        comprobante: {
            handler() {
                this.checkFormValidity();
            },
            deep: true
        }
    },
    data() {
        return {
            currentStep: 1,
            selectedBancoId: null,
            bancoAutocompletado: false,
            validandoCbu: false,
            isFormValid: false,
            check: true,
            nombreCbu: '',
            formValid: false,
            titular: '',
            activos: [],
            cbu: {
                deb_cbu1: '',
                deb_cbu2: '',
                deb_estado: 'PA',
                deb_cbucompleto: '',
                banco: null,
                bco_nombre: ''
            },
            afiliado: {
                afi_apellido: '',
                afi_nombres: '',
                afi_nroafi: '',
                conteoCbu: '',
                conteoTarj: '',
                nomYApe: '',
                afi_fecafil: null,
                afi_fececivil: null,
                afi_fecmat: null,
                afi_fecnacim: null,
                afi_fecnivdesde: null,
                afi_fectit: null,
                afi_segfallecdesde: null
            },
            modifVenc: [],
            nomYApe: '',
            tarj: [],

            header: [
                { text: 'NUMERO', value: 'nro', sortable: false, align: 'center', class: 'primary--text  font-weight-bold' },
                { text: 'TIPO DE APORTE', value: 'det', sortable: false, align: 'center', class: 'primary--text  font-weight-bold' },
                { text: '', value: 'abr', align: 'center', sortable: false, class: 'primary--text  font-weight-bold' },
                /*   { text: 'DESCRIPCION', value: 'detalle_resumen', align: 'center', sortable: false, class: 'primary--text text--darken-1' }, */
                /*   { text: 'DETALLE', value: 'ver_detalle', align: 'center', sortable: false, class: 'primary--text  font-weight-bold' },
                  { text: 'DESCARGAR', value: 'descarga', align: 'center', sortable: false, class: 'primary--text  font-weight-bold' } */
            ],
        }
    },
    methods: {
        ...mapActions('mediosDePago', ['getBancos', 'validarCBU', 'procesaMediosPago']),

        async validarCbu() {
            // Actualizar deb_cbu1 y deb_cbu2 al cargar el CBU completo
            if (this.cbu.deb_cbucompleto && this.cbu.deb_cbucompleto.length === 22) {
                this.cbu.deb_cbu1 = this.cbu.deb_cbucompleto.substring(0, 8);
                this.cbu.deb_cbu2 = this.cbu.deb_cbucompleto.substring(8);
            } else {
                this.cbu.deb_cbu1 = '';
                this.cbu.deb_cbu2 = '';
                this.selectedBancoId = null;
                this.cbu.banco = null;
                this.bancoAutocompletado = false;
            }
            if (!this.cbu.deb_cbucompleto || this.cbu.deb_cbucompleto.length !== 22) return;
            const payload = { cbu: this.cbu.deb_cbucompleto };
            const result = await this.validarCBU(payload);
            this.bancoAutocompletado = false;
            if (result && this.bancos && this.bancos.length > 0) {
                let entidad = this.entidadBancaria;
                if (entidad) {
                    const bancoEncontrado = this.bancos.find(b => (b.nombre || '').toUpperCase() === entidad.toUpperCase());
                    if (bancoEncontrado) {
                        this.selectedBancoId = bancoEncontrado.id;
                        this.cbu.banco = bancoEncontrado.id;
                        this.cbu.bco_nombre = bancoEncontrado.nombre;
                        this.bancoAutocompletado = true;
                    }
                }
            }
            if (!this.bancoAutocompletado && this.selectedBancoId) {
                this.cbu.banco = this.selectedBancoId;
            }
            this.checkFormValidity();
            // Actualizar los seleccionados con el nuevo CBU
            // this.updateDestForActivos();
        },
        /*         updateDestForActivos() {
                    if (!this.cbu.deb_cbucompleto || this.cbu.deb_cbucompleto.length !== 22) return;
                    const label = `CBU ${this.cbu.deb_cbucompleto}`;
                    (this.activos || []).forEach(item => {
                        if (item) {
                            this.$set(item, 'dest', label);
                            this.$set(item, 'dest_or', label);
                        }
                    });
                }, */

        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },
        handleFileSelected() {
            if (this.comprobante.length == 1) {
                this.formValid = true
            } else {
                this.formValid = false;
            }

            this.$nextTick(() => {
                this.checkFormValidity();
            });
        },

        forzarValidacion() {
            this.$refs.obs.validate().then(result => {
                if (!result) {
                    const firstErrorElement = this.$el.querySelector('.v-messages__message');
                    if (firstErrorElement) firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        },
        editarCuenta() {
            // Validaciones básicas
            this.$refs.obs.validate().then(result => {
                if (result) {
                    // Si la validación es exitosa, continuar con la edición
                    this.updateDestForActivos();
                    const afiliadoObj = {
                        afi_nroafi: this.afiliado.afi_nroafi || this.user.nroafi || null,
                        afi_fecnacim: this.afiliado.afi_fecnacim || null,
                        afi_fecmat: this.afiliado.afi_fecmat || null,
                        afi_fecafil: this.afiliado.afi_fecafil || null,
                        afi_fececivil: this.afiliado.afi_fececivil || null,
                        afi_fectit: this.afiliado.afi_fectit || null,
                        afi_segfallecdesde: this.afiliado.afi_segfallecdesde || null,
                        afi_fecnivdesde: this.afiliado.afi_fecnivdesde || null,
                        conteoCbu: this.afiliado.conteoCbu || 0,
                        conteoTarj: this.afiliado.conteoTarj || 0,
                        nomYApe: this.afiliado.nomYApe || ((this.user.apellido || '') + ', ' + (this.user.nombres || '')),
                        afi_apellido: this.afiliado.afi_apellido || this.user.apellido || '',
                        afi_nombres: this.afiliado.afi_nombres || this.user.nombres || ''
                    };
                    const cbuObj = {
                        deb_cbu1: this.afi_debautos.deb_cbu1,
                        deb_cbu2: this.afi_debautos.deb_cbu2,
                        deb_titular: this.afi_debautos.deb_titular,
                        banco: this.afi_debautos.banco,
                        deb_estado: 'PA',
                        deb_cbualias: '',
                        deb_detalle: '',
                        deb_id: ''
                    }
                    const payload = {
                        cbu: [cbuObj] || [],
                        activos: this.activos || [],
                        tarj: [],
                        modifVenc: [],
                        afiliado: afiliadoObj
                    };
                    const fd = new FormData();
                    const appendArrayObjects = (arr, key) => {
                        // Para cbu, tarj y modifVenc: no enviar nada si están vacíos (opción 1)
                        const omitIfEmpty = ['cbu', 'tarj', 'modifVenc'];
                        if (!arr || !arr.length) {
                            if (omitIfEmpty.includes(key)) return; // no append
                            // Si se quisiera mantener '[]' para otros arrays vacíos, se podría dejar:
                            // fd.append(key, '[]');
                            return;
                        }
                        arr.forEach((obj, i) => {
                            Object.entries(obj || {}).forEach(([k, v]) => {
                                fd.append(`${key}[${i}][${k}]`, v == null ? '' : v);
                            });
                        });
                    };
                    appendArrayObjects(payload.cbu, 'cbu');
                    appendArrayObjects(payload.activos, 'activos');
                    appendArrayObjects(payload.tarj, 'tarj');
                    appendArrayObjects(payload.modifVenc, 'modifVenc');
                    Object.entries(payload.afiliado).forEach(([k, v]) => fd.append(`afiliado[${k}]`, v == null ? '' : v));
                    const file = this.comprobante[0];
                    fd.append('comprobante', file, file.name || 'comprobante');
                    this.procesaMediosPago(fd);
                    //this.$store.dispatch('mediosDePago/procesaMediosPago', fd);
                }
                else {
                    this.showSnack({ message: 'Por favor, completa todos los campos requeridos.', type: '400' });
                }
            })

        },
        async checkFormValidity() {
            // Esperar un tick para que Vue actualice el DOM
            await this.$nextTick();

            if (this.$refs.obs) {
                const isValid = await this.$refs.obs.validate();
                const hasFile = this.comprobante && this.comprobante.length > 0;

                this.isFormValid = isValid && hasFile;

                // Emitir el estado al padre
                this.$emit('validityChanged', this.isFormValid);
            }
        }
    },
    computed: {
        ...mapGetters('dataUser', ['comprobante']),
        ...mapGetters('mediosDePago', ['bancos', 'selectedBancoId', 'aportesActivosAfi', 'tiposMediosPagos', 'entidadBancaria']),
        ...mapGetters('auth', ['user']),

    },

    props: {
        accion: {
            type: String,
            default: 'nuevo'
        },
        item: {
            required: false
        },
        // Cuando se usa desde el flujo de plan de pago el aviso CVU se unifica
        // con el de titularidad en el componente padre (FormSeleccionarCuenta),
        // por eso se oculta aca para no duplicarlo. En MediosDePago.vue el
        // aviso se sigue mostrando (default false).
        ocultarAvisoCvu: {
            type: Boolean,
            default: false
        }
    },
}

</script>

<style>
/* Estilos opcionales del formulario de edición de cuenta */
.form-footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.15);
}
</style>
